import { createContext } from 'react';
var LocaleContext = /*#__PURE__*/createContext(undefined);
export default LocaleContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/locale-provider/context.js
// module id = 210
// module chunks = 0